







































import { Component, Vue, Prop } from "vue-property-decorator";
import VDelete from "../../../components/VDelete.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { Construction } from "../../api/construction-api";
import Staff from "../../../entities/staff";

@Component({
  components: {
    VDelete,
    SwitchButton
  },
  props: {
    removable: {
      type: Boolean,
      default: false
    }
  }
})
export default class ConstructionEdit extends Vue {
  @Prop({ required: true }) construction!: Construction;

  get templateOptions(): SelectOption[] {
    return this.$store.getters.serviceTaskTypeOptions.concat([
      { text: "非表示", value: "0" }
    ]);
  }

  private staffs: Staff[] = [];

  get staffOptions() {
    return [
      {
        text: "全て",
        value: ""
      }
    ].concat(
      this.staffs.map(s => ({
        text: s.name,
        value: String(s.id)
      }))
    );
  }

  status = "";

  submit() {
    this.status = "progressing";
    this.$emit("ok");
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }
}
